export default __webpack_public_path__ + "static/media/belt_of_the_wicked.71b6a074.jpg";